import React, { useEffect, useState } from 'react';
import useNamedLink from '../../../components/NamedLink/useNamedLink';
import { useHistory } from 'react-router-dom';
import {
  createSlug,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
} from '../../../util/urlHelpers';
import { getListing } from '../../TopbarContainer/Topbar/TopbarDesktop/CustomLinksMenu/PriorityLinks';

const AfterLoginMove = props => {
  const { user } = props;
  const history = useHistory();
  const [listing, setListing] = useState([]);
  const [listingLoading, setListingLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const result = await getListing();
      const findPublicListing = result?.find(listing => {
        return (
          listing?.attributes?.state === 'published' ||
          listing?.attributes?.state === 'draft' ||
          listing?.attributes?.state === 'closed'
        );
      });
      setListing(findPublicListing);
      setListingLoading(false);
    })();
  }, []);

  const isListingExist = !!listing;
  const isListingDraft = listing?.attributes?.state === 'draft';

  const { moveTo } = useNamedLink({
    name: isListingExist ? 'EditListingPage' : 'NewListingPage',
    params: isListingExist
      ? {
          id: listing?.id?.uuid || '',
          slug: createSlug(listing?.attributes?.title || ''),
          type: isListingDraft ? LISTING_PAGE_PARAM_TYPE_DRAFT : LISTING_PAGE_PARAM_TYPE_EDIT,
          tab: 'details',
        }
      : undefined,
  });

  useEffect(() => {
    if (user) {
      if (user?.attributes?.profile?.publicData?.userType === 'parent') {
        history?.push(
          '/s?bounds=70.27136381%2C-65.96768192%2C-7.15309963%2C-129.42471317&pub_categoryLevel1=doula'
        );
      }
      if (user?.attributes?.profile?.publicData?.userType === 'care-provider' && !listingLoading) {
        moveTo();
      }
    }
  }, [user, listingLoading]);

  return <div></div>;
};

export default AfterLoginMove;
